// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostoječiKorisnikStepOne_filtersContainer__ZCd7b {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 30px;
  margin-top: 30px;
}
.PostoječiKorisnikStepOne_searchContainer__JEkJp {
  margin-top: 30px;
  margin-bottom: 30px;
}

.PostoječiKorisnikStepOne_container__Odpet {
  display: flex;
  flex-direction: column;
}

.PostoječiKorisnikStepOne_contentContainer__iwiZ3 {
  margin-bottom: 50px;
}

.PostoječiKorisnikStepOne_filteri__zWgRC {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  width: 100%;
  margin-bottom: 30px;
}

.PostoječiKorisnikStepOne_buttonContainer__TKGLZ {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  gap: 20px;
}
.PostoječiKorisnikStepOne_cancelButton__RGjeZ {
  background: #ebebeb;
  color: #808080;
}
.PostoječiKorisnikStepOne_cancelButton__RGjeZ,
.PostoječiKorisnikStepOne_nextButton__h3yMs,
.PostoječiKorisnikStepOne_nextButtonDisabled__p\\+oPE {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  text-align: center;
  border: none;
  transition: background-color 300ms ease-in-out;
  cursor: pointer;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.PostoječiKorisnikStepOne_cancelButton__RGjeZ:hover {
  background-color: #cccbcb;
}
.PostoječiKorisnikStepOne_nextButton__h3yMs:hover {
  background-color: #b48a28;
}
.PostoječiKorisnikStepOne_nextButton__h3yMs {
  background: #cb9c2d;
  color: #ffffff;
}
.PostoječiKorisnikStepOne_nextButtonDisabled__p\\+oPE,
.PostoječiKorisnikStepOne_disabledButton__rHO\\+x {
  background-color: #cbba92;
  color: #ffffff;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/IPDTeam/DodajDjelatnika/ContentComponents/AddUserFirstStep/Postoje%C4%8DiKorisnikStepOne.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;EAGE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".filtersContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n.searchContainer {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n}\n\n.contentContainer {\n  margin-bottom: 50px;\n}\n\n.filteri {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 30px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.buttonContainer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n.cancelButton {\n  background: #ebebeb;\n  color: #808080;\n}\n.cancelButton,\n.nextButton,\n.nextButtonDisabled {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  text-align: center;\n  border: none;\n  transition: background-color 300ms ease-in-out;\n  cursor: pointer;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.cancelButton:hover {\n  background-color: #cccbcb;\n}\n.nextButton:hover {\n  background-color: #b48a28;\n}\n.nextButton {\n  background: #cb9c2d;\n  color: #ffffff;\n}\n.nextButtonDisabled,\n.disabledButton {\n  background-color: #cbba92;\n  color: #ffffff;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filtersContainer": `PostoječiKorisnikStepOne_filtersContainer__ZCd7b`,
	"searchContainer": `PostoječiKorisnikStepOne_searchContainer__JEkJp`,
	"container": `PostoječiKorisnikStepOne_container__Odpet`,
	"contentContainer": `PostoječiKorisnikStepOne_contentContainer__iwiZ3`,
	"filteri": `PostoječiKorisnikStepOne_filteri__zWgRC`,
	"buttonContainer": `PostoječiKorisnikStepOne_buttonContainer__TKGLZ`,
	"cancelButton": `PostoječiKorisnikStepOne_cancelButton__RGjeZ`,
	"nextButton": `PostoječiKorisnikStepOne_nextButton__h3yMs`,
	"nextButtonDisabled": `PostoječiKorisnikStepOne_nextButtonDisabled__p+oPE`,
	"disabledButton": `PostoječiKorisnikStepOne_disabledButton__rHO+x`
};
export default ___CSS_LOADER_EXPORT___;
